import { OptionDescription } from 'shared/types/general';
import { ITabTableLayerRow } from './types';

const getIdFromElement = (element: number | OptionDescription): number => {
  return typeof element === 'number' ? element : Number(element?.id);
};

export const normalizeRows = (
  elements: Array<number | OptionDescription> = [],
  options: OptionDescription[] = []
) => {
  const optionMap = new Map(options.map((opt) => [Number(opt.id), opt]));

  return elements
    .map((element) => {
      const id = getIdFromElement(element);
      const option = optionMap.get(id);
      const elementObj = typeof element === 'object' ? element : null;

      if (!id) {
        return null;
      }

      const code = elementObj?.code ?? option?.code;
      const description = elementObj?.description ?? option?.description;

      if (!code) {
        return null;
      }

      return {
        id,
        code,
        description
      } as ITabTableLayerRow;
    })
    .filter(Boolean) as ITabTableLayerRow[];
};
